export enum EventAction {
    Select = 'Select',
    Click = 'Click'
}